import React, { Component, useEffect } from 'react';
import { Route, Routes, useLocation } from 'react-router-dom';
import { Layout } from './components/Layout';
import { Home } from './components/Home';
import { FetchData } from './components/FetchData';
import { Counter } from './components/Counter';
import { Program } from './components/Program';
import { Program2 } from './components/Program-2';
import {Insentive} from './components/Insentive';
import {AboutUs} from './components/AboutUs';
import {Sendbox} from './components/Phuketsendbox'
import {Console} from './components/Console'
import {Login} from './components/Login'
import {PrivateRoute} from './components/PrivateRoute'
import {ProgramPlusView} from './components/ProgramPlusView'
import {ProgramSearch} from './components/ProgramSearch'
import {GroupRequest} from './components/GroupRequest'


import './custom.css'

function ScrollToTop() {
  var location = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
    document.querySelectorAll('main').forEach(m => m.scrollTo && m.scrollTo(0, 0));
  }, [location.pathname]);
  return null;
}

export default class App extends Component {
  static displayName = App.name;

  render () {

    return (
      <>
      <ScrollToTop />
      <Routes>
        <Route path='/login' element={<Login />} />
        <Route path='/console/*' element={
          <PrivateRoute>
            <Console />
          </PrivateRoute>
        } />
        <Route path='*' element={
          <Layout>
            <Routes>
              <Route exact path='/' element={<Home />} />
              <Route path='/counter' element={<Counter />} />
              <Route path='/fetch-data' element={<FetchData />} />
              <Route path='/program/:id' element={<Program />} />
              <Route path='/program2' element={<Program2 />} />
              <Route path='/insentive' element={<Insentive />} />
              <Route path='/AboutUs' element={<AboutUs />} />
              <Route path='/phuketsendbox' element={<Sendbox />} />
              <Route path='/programplus/view/:id' element={<ProgramPlusView />} />
              <Route path='/programs/search' element={<ProgramSearch />} />
              <Route path='/group-request' element={<GroupRequest />} />
            </Routes>
          </Layout>
        } />
      </Routes>
      </>
    )
  }
}
